import { translitToRus } from 'app/utils';
import { createSelector } from 'reselect';
const trailerState = (state) => state.trailer;
const compareNullableText = (left, right, order) => {
    if (right === null) {
        return -1;
    }
    if (left === null) {
        return 1;
    }
    return order === 'ASC'
        ? left.localeCompare(right, undefined, { sensitivity: 'base' })
        : right.localeCompare(left, undefined, { sensitivity: 'base' });
};
export const itemsTrailerSelector = createSelector(trailerState, (trailer) => trailer.items);
export const searchValueTrailerSelector = createSelector(trailerState, (trailer) => trailer.searchValue);
export const selectedItemTrailerSelector = createSelector(trailerState, (trailer) => trailer.selectedItem);
export const sortSelectedItemTrailerSelector = createSelector(trailerState, (trailer) => trailer.sortSelectedItem);
export const sortItemsTrailerSelector = createSelector([itemsTrailerSelector, sortSelectedItemTrailerSelector, searchValueTrailerSelector], (items, sortSelectedItem, searchValue) => {
    const compareFn = (a, b) => {
        switch (sortSelectedItem.name) {
            case 'number':
                return compareNullableText(a.number, b.number, sortSelectedItem.order);
            case 'vin':
                return compareNullableText(a.vin, b.vin, sortSelectedItem.order);
            default: {
                const field = sortSelectedItem.name;
                switch (typeof a[field]) {
                    case 'string':
                        return compareNullableText(a.number, b.number, sortSelectedItem.order);
                    case 'number': {
                        const left = Number(a[field]);
                        const right = Number(b[field]);
                        return sortSelectedItem.order === 'ASC' ? left - right : right - left;
                    }
                    default:
                        return 0;
                }
            }
        }
    };
    const query = translitToRus(searchValue);
    const source = searchValue.length
        ? items.filter((item) => {
            var _a, _b;
            const sensor = translitToRus(String(item.fuel_level_sensor));
            const number = translitToRus((_a = item.number) !== null && _a !== void 0 ? _a : '');
            const vin = translitToRus((_b = item.vin) !== null && _b !== void 0 ? _b : '');
            return sensor.indexOf(query) >= 0 || number.indexOf(query) >= 0 || vin.indexOf(query) >= 0;
        })
        : items;
    return [...source].sort(compareFn);
});
